import styled from 'styled-components';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';

import appTheme from '../../themes/Theme';

export const StyledWrapper = styled.div`
  cursor: pointer;
  border-radius: 3px;
  padding: 4px 4px 4px 16px;
  margin-bottom: 4px;
  height: 28px;
  display: flex;
  align-items: center;
  background-color: ${(props) => props.isActive && appTheme.itemSideBarColor};

  &:hover {
    background-color: ${appTheme.itemSideBarColor};
  }
`;

export const StyledWrapChildren = styled.div`
  margin-left: 16px;
`;

export const StyledTitle = styled.h3`
  color: ${(props) => props.isActive ? '#51c3a0' : appTheme.sideBarTextColor};
  font-size: 16px;
  font-weight: bold;
`;

export const StyledExpandMoreIcon = styled(ExpandMoreIcon)`
  color: ${appTheme.iconItemSideBarColor};
`;

export const StyledKeyboardArrowRightIcon = styled(KeyboardArrowRightIcon)`
  color: ${appTheme.iconItemSideBarColor};
`;
